import { CharacterClassIcon } from 'app/frontend/base/components'
import { CharacterClass } from 'app/frontend/types/custom'
import { useMemo } from 'react'
import { v4 as uuid } from 'uuid'
import { SpecializationOption } from '../hooks/useTeamPlanComputedData'
import { useTeamPlanTimeline } from './TeamPlanTimelineContext'
import { Button } from '@/components/ui/button'
import AddActorRosterMenu from './AddActorRosterMenu'
import ActorSpecializationMenu from './ActorSpecializationMenu'

const AddActorBar = () => {
  const { computed, timeline, showRosterImport, updateTimeline } =
    useTeamPlanTimeline()

  const specializationGroups = useMemo(() => {
    const byClass: Record<
      number,
      {
        classId: number
        className: string
        specializations: SpecializationOption[]
      }
    > = {}
    computed.specializations.forEach((spec) => {
      if (!byClass[spec.classId]) {
        byClass[spec.classId] = {
          classId: spec.classId,
          className: spec.className,
          specializations: [],
        }
      }
      byClass[spec.classId].specializations.push(spec)
    })
    return Object.values(byClass).sort((a, b) =>
      a.className.localeCompare(b.className),
    )
  }, [computed.specializations])

  const addSpecialization = (spec: SpecializationOption) => {
    const count = timeline.actors.filter(
      (actor) => actor.spec_id === spec.id,
    ).length
    updateTimeline((next) => {
      next.actors.push({
        uuid: uuid(),
        spec_id: spec.id,
        class_id: spec.classId,
        label: `${spec.name} ${count + 1}`,
        casts: [],
      })
    })
  }

  const addClassActor = (classId: number, className: string) => {
    const count = timeline.actors.filter(
      (actor) => actor.class_id === classId && actor.spec_id === null,
    ).length
    updateTimeline((next) => {
      next.actors.push({
        uuid: uuid(),
        spec_id: null,
        class_id: classId,
        label: `${className} ${count + 1}`,
        casts: [],
      })
    })
  }

  return (
    <div className='flex items-center gap-2 flex-wrap'>
      <span className='whitespace-nowrap mr-1'>Add</span>
      {specializationGroups.map((group) => (
        <ActorSpecializationMenu
          key={group.classId}
          group={group}
          onSelectClass={addClassActor}
          onSelectSpecialization={addSpecialization}
          trigger={
            <Button
              size='sm'
              variant='outline'
              className='p-1 h-8 w-8 min-w-8 min-h-8'
            >
              <CharacterClassIcon
                characterClass={group.className as CharacterClass}
                className='w-6 h-6 border-none min-w-6 min-h-6'
              />
            </Button>
          }
        />
      ))}
      {showRosterImport ? <AddActorRosterMenu /> : null}
    </div>
  )
}

export default AddActorBar
